module.exports = __webpack_public_path__ + "media/customizations/wildblue/logo-5e242251db6943fe747db240c8b949b6.png";